module.exports = __webpack_public_path__ + "img/PL08037.6e0974ea.png";